export default {"src":"/_next/static/media/circle-solid-green.a54e6baa.svg","height":512,"width":512};